export default __webpack_public_path__ + "static/media/fahr0.6086a91f.svg";